import parseHTML from '../../../utilities/parseHTML';

const headlinePropsTransformer = (props) =>
{
    const { name, description } = props;

    return {
        title: name ? parseHTML(name, ['learningCenter']).parsed : '',
        description: description ? parseHTML(description, ['learningCenter']).parsed : '',
    }
}

export default headlinePropsTransformer;
